import { axios } from '@/services/axios';

export const createSpecialNumber = (specialNumberData) => {
    return axios.post('/specialnumber/', specialNumberData);
};
